'use es6';

import PropTypes from 'prop-types';
import { Map as ImmutableMap } from 'immutable';
import SortValues from 'SalesContentIndexUI/data/constants/SortValues';
import SearchSortRecord from 'SalesContentIndexUI/data/records/SearchSortRecord';
import sort from 'SalesContentIndexUI/data/utils/sort';
import TableColumnRecord from 'SalesContentIndexUI/data/records/TableColumnRecord';
import { SortTH } from 'foundations-components/transitional/components/Table';
import { jsx as _jsx } from "react/jsx-runtime";
const sortOrderNameMap = ImmutableMap({
  ascending: SortValues.ASC,
  descending: SortValues.DESC,
  [SortValues.ASC]: 'ascending',
  [SortValues.DESC]: 'descending'
});
const IndexTableHeaderCell = ({
  columnData,
  currentSort,
  setSort
}) => {
  const {
    searchField,
    name
  } = columnData;
  if (!searchField) {
    return /*#__PURE__*/_jsx("th", {
      children: name
    });
  }
  const selectedSort = currentSort && currentSort.field === searchField ? sortOrderNameMap.get(currentSort.order) : 'none';
  return /*#__PURE__*/_jsx(SortTH, {
    sort: selectedSort,
    onSortChange: ({
      target: {
        value
      }
    }) => setSort({
      selectedSort: sort(searchField, sortOrderNameMap.get(value))
    }),
    children: name
  });
};
IndexTableHeaderCell.propTypes = {
  currentSort: PropTypes.instanceOf(SearchSortRecord),
  columnData: PropTypes.instanceOf(TableColumnRecord).isRequired,
  setSort: PropTypes.func.isRequired
};
export default IndexTableHeaderCell;